<template>
    <div class="page-container" :class="{ collapsed: !$store.getters.sidebarOpened }">
        <div class="data-container center-area" style="width: 100%">
            <div class="tool-box">
                <el-button type="primary" :icon="Refresh" @click="resetQueryForm">刷新</el-button>
            </div>
            <el-form class="search-form" ref="search_form" :inline="true" :model="search_params" label-position="top">
                <el-form-item label="名称" prop="name">
                    <el-input style="width: 165px" v-model="search_params.name" clearable placeholder="请输入名称" />
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" :icon="Search" plain @click="getTableData">搜索</el-button>
                    <el-button :icon="Refresh" @click="resetQueryForm">重置</el-button>
                </el-form-item>
            </el-form>
            <el-table :data="table_data" v-loading="tableLoading">
                <el-table-column label="户名姓名" prop="name" align="center"></el-table-column>
                <el-table-column label="变动金额" prop="amount" align="center"></el-table-column>
                <el-table-column label="操作类型" prop="operator_type" align="center">
                    <template #default="{ row }">
                        <el-tag v-if="row.operator_type === '1'" type="success">系统扣费</el-tag>
                        <el-tag v-else-if="row.operator_type === '2'" type="danger">平台用户</el-tag>
                        <el-tag v-else>户主</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作者" prop="operator" align="center"></el-table-column>
                <el-table-column label="变动前金额" prop="pre_changed" align="center"></el-table-column>
                <el-table-column label="变动后金额" prop="after_changed" align="center"></el-table-column>
            </el-table>
            <Pagination
                v-if="table_data.length > 0"
                :current-page="page_params.page"
                :page-size="page_params.page_size"
                :total="total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
            />
        </div>
    </div>
</template>

<script setup>
import { onMounted, reactive, ref, watch } from 'vue'
import { Refresh, Search } from '@element-plus/icons'
import { getAccountLogLists } from '@/api/household.js'
import { ElMessage } from 'element-plus'
import Pagination from '@/components/Pagination/index.vue'

// 重置
const search_form = ref(null)
const resetQueryForm = () => {
    search_form.value.resetFields()
    getTableData()
}
// 数据源
const search_params = reactive({
    name: ''
})

const table_data = ref([])
const tableLoading = ref(true)
const total = ref(0)

// 获取列表数据
async function getTableData() {
    tableLoading.value = true
    const params = { ...search_params, ...page_params }
    try {
        const { lists, total: total_count } = await getAccountLogLists(params)
        table_data.value = lists
        total.value = total_count
        tableLoading.value = false
    } catch (err) {
        console.log(err)
        tableLoading.value = false
    }
}

// 分页相关
const page_params = reactive({
    page: 1,
    page_size: 10
})
const handleSizeChange = (currentSize) => {
    page_params.page_size = currentSize
    page_params.page = 1
    getTableData()
}
const handleCurrentChange = (currentPage) => {
    page_params.page = currentPage
    getTableData()
}

const formDialogVisible = ref(false)
const isForm = ref(false) // 是否是表单
const selectModelId = ref('') // 点中的模块id
const detail_data = ref({})
// 保证每次打开重新获取数据
watch(formDialogVisible, (val) => {
    if (!val) selectModelId.value = ''
})
// 切换到前台时候执行
onMounted(() => {
    getTableData()
})
</script>

<style scoped></style>
